module.exports = __webpack_public_path__ + "fbba87fbf0a95dcf7390d7d34135e9c5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/truck.png
// module id = 2444
// module chunks = 0